<proffeo-ui-page-wrapper>
  <div class="flex w-full flex-col gap-4 px-5 pb-5 pt-3 max-sm:px-2 max-md:px-3 max-md:pb-3 lg:pt-6">
    @if (!companyId()) {
      <p class="text-proffeo-muted">{{ 'cooperations.please-select-company-first' | translate }}</p>
    } @else if (!cooperation()) {
      <p class="text-proffeo-muted">{{ 'cooperations.not-found' | translate }}</p>
      <proffeo-ui-button
        (clicked)="goBack()"
        [text]="'common.back' | translate"
        variant="secondary"
      ></proffeo-ui-button>
    } @else if (cooperation(); as cooperation) {
      <div
        class="flex flex-col gap-4 rounded-md border border-proffeo-overlay-subtle bg-proffeo-surface p-4 max-sm:px-2"
      >
        <div class="flex flex-wrap items-center justify-between gap-2">
          <h2 class="text-lg text-proffeo-text">{{ partnerName() }}</h2>
          <span class="rounded px-1.5 py-0.5 text-xs">
            {{ statusLabel() | translate }}
          </span>
        </div>
        <div class="flex flex-col gap-2">
          <p class="text-sm text-proffeo-text">
            <span>{{ 'cooperations.description' | translate }}:</span>
            {{ cooperation.description }}
          </p>
        </div>
        <proffeo-cooperation-projects-list
          [cooperationId]="cooperationId()"
          [writable]="true"
        />
        <proffeo-cooperation-groups-list [cooperationId]="cooperationId()" />
        <proffeo-cooperation-users-list [cooperationId]="cooperationId()" />
        <div class="flex flex-wrap gap-2">
          <proffeo-ui-button
            (clicked)="goBack()"
            [text]="'common.back' | translate"
            variant="secondary"
          ></proffeo-ui-button>
        </div>
      </div>
    }
  </div>
</proffeo-ui-page-wrapper>
